export default __webpack_public_path__ + "static/media/flash07.d93879e8.png";